import { useState, useEffect } from 'react';
import Web3 from 'web3';
import { NETWORKS } from '../config/networkConfig';

export function useWallet() {
  const [isConnected, setIsConnected] = useState(false);
  const [account, setAccount] = useState('');

  useEffect(() => {
    checkConnection();
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', handleAccountsChanged);
      window.ethereum.on('chainChanged', handleChainChanged);
      return () => {
        window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
        window.ethereum.removeListener('chainChanged', handleChainChanged);
      };
    }
  }, []);

  const checkConnection = async () => {
    if (typeof window.ethereum !== 'undefined') {
      try {
        const web3 = new Web3(window.ethereum);
        const accounts = await web3.eth.getAccounts();
        if (accounts.length > 0) {
          setIsConnected(true);
          setAccount(accounts[0]);
        }
      } catch (error) {
        console.error('Error checking connection:', error);
      }
    }
  };

  const handleAccountsChanged = (accounts) => {
    if (accounts.length === 0) {
      setIsConnected(false);
      setAccount('');
    } else {
      setIsConnected(true);
      setAccount(accounts[0]);
    }
  };

  const handleChainChanged = () => {
    window.location.reload();
  };

  const connectWallet = async () => {
    if (typeof window.ethereum !== 'undefined') {
      try {
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        const web3 = new Web3(window.ethereum);
        const accounts = await web3.eth.getAccounts();
        setIsConnected(true);
        setAccount(accounts[0]);
        await switchToEarthNetwork();
      } catch (error) {
        console.error('Error connecting to MetaMask', error);
      }
    }
  };

  const disconnectWallet = () => {
    setIsConnected(false);
    setAccount('');
  };

  const switchToEarthNetwork = async () => {
    if (window.ethereum) {
      try {
        await window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: `0x${Number(process.env.REACT_APP_EARTH_CHAIN_ID).toString(16)}` }],
        });
      } catch (switchError) {
        if (switchError.code === 4902) {
          try {
            await window.ethereum.request({
              method: 'wallet_addEthereumChain',
              params: [
                {
                  chainId: `0x${Number(process.env.REACT_APP_EARTH_CHAIN_ID).toString(16)}`,
                  chainName: 'Earth Network',
                  nativeCurrency: {
                    name: process.env.REACT_APP_EARTH_NATIVE_CURRENCY_NAME,
                    symbol: process.env.REACT_APP_EARTH_NATIVE_CURRENCY_SYMBOL,
                    decimals: parseInt(process.env.REACT_APP_EARTH_NATIVE_CURRENCY_DECIMALS, 10)
                  },
                  rpcUrls: [process.env.REACT_APP_EARTH_RPC_URL],
                  blockExplorerUrls: [process.env.REACT_APP_EARTH_EXPLORER_URL]
                },
              ],
            });
          } catch (addError) {
            console.error('Error adding Earth network:', addError);
          }
        } else {
          console.error('Error switching to Earth network:', switchError);
        }
      }
    }
  };

  return { isConnected, account, connectWallet, disconnectWallet, switchToEarthNetwork };
}